import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        <path
          d="M 11.597 21.436 L 5.835 21.436 L 5.835 35.694 L 0 35.694 L 0 0 L 10.083 0 Q 16.705 0 20.03 2.377 A 8.505 8.505 0 0 1 20.313 2.588 A 8.297 8.297 0 0 1 23.309 7.393 A 13.102 13.102 0 0 1 23.633 10.401 A 9.81 9.81 0 0 1 22.575 15.023 Q 20.924 18.172 16.699 19.898 L 26.782 35.694 L 20.142 35.694 L 11.597 21.436 Z M 5.835 4.932 L 5.835 16.602 L 9.888 16.602 Q 13.965 16.602 15.796 15.088 A 4.856 4.856 0 0 0 17.425 12.412 Q 17.624 11.598 17.627 10.627 A 9.669 9.669 0 0 0 17.627 10.596 A 7.261 7.261 0 0 0 17.453 8.949 Q 17.196 7.849 16.563 7.074 A 4.132 4.132 0 0 0 15.649 6.25 Q 13.754 4.986 10.018 4.934 A 23.285 23.285 0 0 0 9.692 4.932 L 5.835 4.932 Z"
          fill="currentColor"
          transform="translate(28, 28)"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
